import React, { FC, useRef, useEffect, useCallback } from 'react';
import classNames from 'classnames';

import { INotification } from '@sv-support-sdk/shared-types/src/common/notifications';
import { DEFAULT_NOTIFICATION_TIMEOUT } from '@sv-support-sdk/utils/src/constants/notifications';

import css from './style.module.scss';

import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

import { useAppDispatch } from '../../../store/hooks';
import notificationActions from '../../../store/actions/notifications';
import { NOTIFICATION_ICONS } from '../../../constants/notifications';

interface IProps {
  notification: INotification;
}

const Notification: FC<IProps> = ({ notification: { id, type, title, message } }) => {
  const dispatch = useAppDispatch();
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const closeHandler = useCallback(
    () => dispatch(notificationActions.removeNotification(id)),
    [dispatch, id],
  );

  const initAutoCloseProcess = useCallback(() => {
    timer.current = setTimeout(() => closeHandler(), DEFAULT_NOTIFICATION_TIMEOUT);
  }, [closeHandler]);

  const cancelAutoCloseProcess = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };

  useEffect(() => {
    initAutoCloseProcess();
    return () => cancelAutoCloseProcess();
  }, [initAutoCloseProcess]);

  return (
    <div
      className={classNames(css.notification, { [css[`notification_type_${type}`]]: type })}
      onMouseEnter={cancelAutoCloseProcess}
      onMouseLeave={initAutoCloseProcess}
    >
      <div className={css.notification__content}>
        <div className={css.notification__icon}>
          <Icon id={NOTIFICATION_ICONS[type]} />
        </div>
        <div className={css.notification__description}>
          <div className={css.notification__title}>{title}</div>
          <div className={css.notification__message}>{message}</div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
